import React, { useState, useEffect } from 'react';
import { Collapse, Form, Row, Col, Select, Popconfirm, Button } from 'antd';
import Input from '../../../../ui/Input';
import styles from './../index.module.css';
import { CloseCircleOutlined, PlusOutlined } from '@ant-design/icons';
import ActionButtonsBar from '../../../../ui/ActionButtonsBar';
import { addContactPerson } from '../../../../../services/contactperson';
import { LocalPersistence } from '../../../../../factories';
import { sessionType } from '../../../../../interfaces';
import Loading from '../../../../Loading';
import './../index.css'

interface dataType {
  type?:string | null,
  firstname?:string | null,
  lastname?:string | null,
  suffix?:string | null,
  companyname?:string | null,
  time?:string | null,
  emailaddress?:string | null,
  phonecountry?:string | null,
  phoneareacity?:string | null,
  phonenumber?:string | null,
  faxcountry?:string | null,
  faxareacity?:string | null,
  faxnumber?:string | null,
  mobilecountry?:string | null,
  mobileareacity?:string | null,
  mobilenumber?:string | null
}

interface propsTypes {
  isEditModle: boolean,
  returnToViewModel: ()=>void,
  refreshPage:number,
  setRefreshPage:(parmas:number)=>void,
  typeList:Array<object>,
  businessTypeList:Array<object>,
  contactPersonDetails:{
    propertylevelcontacts?:Array<object>,
    chainlevelcontacts?:Array<object>,
  }
}

interface typeTypes {
  codeName?: string | undefined,
  codeType?: string | undefined,
  codeValue?: string | undefined,
  id?: number | undefined,
  subCat?: null
}

const Option = Select.Option
const { Panel } = Collapse;
const PropertyLevelContacts = (props:propsTypes)=>{
  const [dataSource, setDataSource] = useState<(dataType | null)[]>(props?.contactPersonDetails?.propertylevelcontacts as Array<dataType | null>)
  const getDefaultOpenKeys = (data: (dataType | null | undefined)[]) => data?.map((k,i) => i + '');
  const [form] = Form.useForm();
  const { isEditModle, returnToViewModel } = props
  const [disableFlag, setDisableFlag] = useState<boolean>(false)
  const [loadingFlag, setLoadingFlag] = useState<boolean>(false)
  const [activeTabKeys, setActiveTabKeys] = useState<string[] | string>(getDefaultOpenKeys(dataSource))
  const validateForm = (changeFlag?:boolean)=>{
    
    if(!isEditModle){
      return 
    }
    form.validateFields().then(() => {
      //if click cancel, do not change disableFlag
      !changeFlag && setDisableFlag(false)
    }).catch((err: { errorFields: { length: number }}) => {
      err?.errorFields?.length ? setDisableFlag(true) : setDisableFlag(false)
    });
  }
 
  const cancelFun = ()=>{
    //validate for clear error message
    validateForm(true)
    returnToViewModel()
  }
  const saveDetail = async () => {
    setDisableFlag(true)
    setLoadingFlag(true)
    const values = form.getFieldsValue()
    const details:Array<object> = [];
    for(const item  in values){
      details.push(values[item])
    }
    const get_session = new LocalPersistence('session')
    const session: sessionType = await get_session.getSessionPersistence()
    const { supplier, propertyId } = session || {} 
    const contactperson = {
      supplier: supplier,
      propertyId: propertyId,
      property: {
          contactperson: {
            propertylevelcontacts: details as Array<object>,
            chainlevelcontacts:props.contactPersonDetails.chainlevelcontacts as Array<object>
          }
      }
    }
    const res = await addContactPerson(contactperson)
    if(res.result.success){
      returnToViewModel()
    }
    setDisableFlag(false)
    setLoadingFlag(false)
    props.setRefreshPage(props.refreshPage+1)
  }
  useEffect(validateForm,[activeTabKeys])
  useEffect(()=>{
    form.setFieldsValue(props.contactPersonDetails.propertylevelcontacts)
    return ()=>{
      setDisableFlag(false)
      setLoadingFlag(false)
    } 
  },[])
  return (
    <div className="property-level-contacts">
      { loadingFlag && <div className="contact-person-loading-wrap"><Loading type="large" /></div> }
      <Form form={form} layout="vertical"  onValuesChange={validateForm}>
        <Collapse ghost activeKey={activeTabKeys} onChange={value=>setActiveTabKeys(value)}>
        {
            dataSource?.map((item,i)=>{
              return item && <Panel 
                collapsible={ isEditModle? 'header' : undefined }
                className="panel-border panael-include-delete" 
                header={`Property Level Contacts ${i + 1}`}
                key={i}
                extra={
                  (isEditModle && dataSource.filter(item=>item).length !== 1) && <Popconfirm
                      placement="leftTop"
                      title={`Are you sure you want to delete Chain Level Contacts ${i + 1}?`}
                      onConfirm={() => {
                        validateForm()
                        let _data = [...dataSource]
                        _data[i]=null; 
                        setDataSource(_data)
                      }}
                      okText="Yes"
                      cancelText="No">
                      <CloseCircleOutlined id={`deletePropertyLevelContacts${i}`} className="panel-btn" />
                  </Popconfirm>
                }
                >
                <Row gutter={24} style={ isEditModle ? {} : {pointerEvents:"none"}}>
                  <Col span={6}>
                    <Form.Item
                      label="Contact Type"
                      name={[i,"type"]}
                      rules={ isEditModle ? [{required:true, message:"This field is required"}] : [] }
                    >
                      {isEditModle? <Select allowClear showSearch>
                        {props?.typeList?.map((item:typeTypes,index:number)=>{
                            return <Option  key={index} value={item.codeName as string}>{item.codeName}</Option>
                          })}
                      </Select> : < Input />
                      }
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Business Type"
                      name={[i,"businesstype"]}
                      rules={ isEditModle ? [{required:true, message:"This field is required"}] : [] }
                    >
                      {isEditModle? <Select allowClear>
                        {props?.businessTypeList?.map((item:typeTypes,index:number)=>{
                          return <Option  key={index} value={item.codeName as string}>{item.codeName}</Option>
                        })}
                      </Select> : <Input />
                      }
                    </Form.Item>
                  </Col>
                  <Col span={12}></Col>

                  <Col span={6}>
                    <Form.Item
                      label="First Name"
                      name={[i,"firstname"]}
                      extra={ isEditModle && <span className={styles.formItemTip}>Lanyon 20 Characters</span> }
                      rules={ isEditModle? [{ max: 20, message: 'You have reached the max character length of 20' }] : [] }
                    >
                      <Input maxLength={0} edit={isEditModle}/>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Last Name"
                      name={[i,"lastname"]}
                      extra={ isEditModle && <span className={styles.formItemTip}>Lanyon 20 Characters</span> }
                      rules={ isEditModle ? [{ max: 20, message: 'You have reached the max character length of 20' }] : [] }
                    >
                      <Input maxLength={0} edit={isEditModle}/>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Suffix"
                      name={[i,"suffix"]}
                      extra={ isEditModle && <span className={styles.formItemTip}>Lanyon 10 Characters</span> }
                      rules={ isEditModle ? [{ max: 10, message: 'You have reached the max character length of 10' }] : [] }
                    >
                      <Input maxLength={0} edit={isEditModle}/>
                    </Form.Item>
                  </Col>
                  <Col span={6}></Col>

                  <Col span={6}>
                    <Form.Item
                      label="Company Name"
                      name={[i,"companyname"]}
                      extra={ isEditModle && <span className={styles.formItemTip}>Lanyon 64 Characters</span> }
                      rules={ isEditModle ? [{ max: 64, message: 'You have reached the max character length of 64' }] : []}
                    >
                      <Input maxLength={64} edit={isEditModle}/>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Title"
                      name={[i,"title"]}
                      extra={ isEditModle && <span className={styles.formItemTip}>Lanyon 64 Characters</span> }
                      rules={ isEditModle ? [{ max: 64, message: 'You have reached the max character length of 64' }] : []}
                    >
                      <Input maxLength={64} edit={isEditModle}/>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Email Address"
                      name={[i,"emailaddress"]}
                      extra={ isEditModle && <span className={styles.formItemTip}>Lanyon 64 Characters</span> }
                      rules={isEditModle ? [
                        { max: 64,
                          message: 'You have reached the max character length of 64' 
                        },
                        {
                          type: 'email',
                          message: 'The input is not valid E-mail!',
                        }
                      ]:[]}
                    >
                      <Input maxLength={64} edit={isEditModle}/>
                    </Form.Item>
                  </Col>
                  <Col span={6}></Col>

                  <Col span={6}>
                    <Form.Item
                        label="Phone Country"
                        name={[i,"phonecountry"]}
                        extra={ isEditModle && <span className={styles.formItemTip}>Lanyon 4 Characters</span> }
                        rules={ isEditModle ? [{ max: 4, message: 'You have reached the max character length of 4' }] : [] }
                      >
                        <Input maxLength={4} edit={isEditModle}/>
                      </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                        label="Phone Area/City"
                        name={[i,"phoneareacity"]}
                        extra={ isEditModle && <span className={styles.formItemTip}>Lanyon 5 Characters</span> }
                        rules={ isEditModle? [{ max: 5, message: 'You have reached the max character length of 5' }] : [] }
                      >
                        <Input maxLength={5} edit={isEditModle}/>
                      </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                        label="Phone Number"
                        name={[i,"phonenumber"]}
                        extra={ isEditModle && <span className={styles.formItemTip}>Lanyon 15 Characters</span> }
                        rules={ isEditModle ? [{ max: 15, message: 'You have reached the max character length of 15' }] : [] }
                      >
                        <Input maxLength={15} edit={isEditModle}/>
                      </Form.Item>
                  </Col>
                  <Col span={6}></Col>

                  <Col span={6}>
                    <Form.Item
                        label="Fax Country"
                        name={[i,"faxcountry"]}
                        extra={ isEditModle && <span className={styles.formItemTip}>Lanyon 4 Characters</span> }
                        rules={ isEditModle ? [{ max: 4, message: 'You have reached the max character length of 4' }] : []}
                      >
                        <Input maxLength={4} edit={isEditModle}/>
                      </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                        label="Fax Area/City"
                        name={[i,"faxareacity"]}
                        extra={ isEditModle && <span className={styles.formItemTip}>Lanyon 5 Characters</span> }
                        rules={ isEditModle ? [{ max: 5, message: 'You have reached the max character length of 5' }] : []}
                      >
                        <Input maxLength={5} edit={isEditModle}/>
                      </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                        label="Fax Number"
                        name={[i,"faxnumber"]}
                        extra={ isEditModle && <span className={styles.formItemTip}>Lanyon 15 Characters</span> }
                        rules={ isEditModle ? [{ max: 15, message: 'You have reached the max character length of 15' }] : []}
                      >
                        <Input maxLength={15} edit={isEditModle}/>
                      </Form.Item>
                  </Col>
                  <Col span={6}></Col>

                  <Col span={6}>
                    <Form.Item
                        label="Mobile Country"
                        name={[i,"mobilecountry"]}
                        extra={ isEditModle && <span className={styles.formItemTip}>Lanyon 4 Characters</span> }
                        rules={ isEditModle ? [{ max: 4, message: 'You have reached the max character length of 4' }] : [] }
                      >
                        <Input maxLength={4} edit={isEditModle}/>
                      </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                        label="Mobile Area/City"
                        name={[i,"mobileareacity"]}
                        extra={ isEditModle && <span className={styles.formItemTip}>Lanyon 5 Characters</span> }
                        rules={ isEditModle ? [{ max: 5, message: 'You have reached the max character length of 5' }] : [] }
                      >
                        <Input maxLength={5} edit={isEditModle}/>
                      </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                        label="Mobile Number"
                        name={[i,"mobilenumber"]}
                        extra={ isEditModle && <span className={styles.formItemTip}>Lanyon 15 Characters</span> }
                        rules={ isEditModle ? [{ max: 15, message: 'You have reached the max character length of 15' }] : [] }
                      >
                        <Input maxLength={15} edit={isEditModle}/>
                      </Form.Item>
                  </Col>
                </Row>
              </Panel>
            })
          }
        </Collapse>
        {isEditModle && <Button
          type="link"
          onClick={() => {
            let _data = dataSource.concat([{}])
            setDataSource(_data)
            let nextActiveKey = _data.length-1+''
            setActiveTabKeys(activeTabKeys.concat(nextActiveKey))
          }}
          icon={<PlusOutlined />}
          style={{ display: 'flex', alignItems: 'center', background: '#fff', float: 'right' }}
        >
          {`Add Property Level Contacts ${dataSource && Object?.keys(dataSource).length + 1}`}
        </Button>}
      </Form>
      <ActionButtonsBar
        onCancel={cancelFun}
        onSave={saveDetail}
        disabledSave={disableFlag}
        show={isEditModle}
      />
    </div>
  )
}

export default PropertyLevelContacts;
